<template>
  <div class="flex flex-column gap-3">
    <div class="legal-text" v-html="legalText" />
    <div class="legal-text" v-html="legalText2" />
  </div>
</template>

<script lang="ts" setup>
import {translate} from "@/composables/i18n";
import type {ComputedRef} from "vue";
import {toRefs} from "vue";
import {computed} from "vue";

const props = defineProps<{
  actionText: string;
}>();

const {actionText} = toRefs(props);

const legalText: ComputedRef<string> = computed(() => {
  return translate("sign_in.legal_collect", {
    privacy: `<a target="_blank" title="${translate(
      "general.privacy",
    )}" href="https://www.graphiteconnect.com/legal/privacy-policy/">${translate("general.privacy")}</a>`,
  });
});

const legalText2: ComputedRef<string> = computed(() => {
  return translate("sign_in.legal_terms", {
    action: actionText.value,
    terms: `<a target="_blank" title="${translate(
      "general.terms",
    )}" href="https://www.graphiteconnect.com/legal/user-terms-and-conditions/">${translate("general.terms")}</a>`,
  });
});
</script>

<style lang="less" scoped>
@import "@/less/global.less";

.legal-text {
  color: #70747f;
  font-size: @font12;
  line-height: 13px;
}
</style>
